import styles from "./registration-stats.module.css"

export default function RegistrationStats({ registrationStats, metadata, onViewRegistrations }) {
	const getStatusColor = (status) => {
		switch (status) {
			case "paid":
				return "#00d4ff"
			case "pending":
				return "#ffa500"
			case "cancelled":
				return "#ff6b6b"
			default:
				return "#808080"
		}
	}

	const getStatusLabel = (status) => {
		return status?.charAt(0).toUpperCase() + status?.slice(1)
	}

	const totalRegistrations = registrationStats.reduce((sum, stat) => sum + stat.count, 0)

	return (
		<div className={styles.statsCard}>
			<div className={styles.sectionHeader}>
				<h2 className={styles.sectionTitle}>Registration Statistics</h2>
				{onViewRegistrations && (
					<button className={styles.viewAllButton} onClick={onViewRegistrations}>
						View All
					</button>
				)}
			</div>

			<div className={styles.totalCount}>
				<span className={styles.totalLabel}>Total Registrations</span>
				<span className={styles.totalValue}>{totalRegistrations}</span>
			</div>

			<div className={styles.statsGrid}>
				{registrationStats.map((stat) => (
					<div key={stat.id} className={styles.statItem} style={{ borderColor: getStatusColor(stat._id) }}>
						<div className={styles.statHeader}>
							<span className={styles.statusIndicator} style={{ backgroundColor: getStatusColor(stat._id) }}></span>
							<span className={styles.statusLabel}>{getStatusLabel(stat._id)}</span>
						</div>
						<div className={styles.statCount}>{stat.count}</div>
						<div className={styles.statPercentage}>
							{totalRegistrations > 0 ? Math.round((stat.count / totalRegistrations) * 100) : 0}%
						</div>
					</div>
				))}
			</div>

			<div className={styles.progressBars}>
				{registrationStats.map((stat) => (
					<div key={stat.id} className={styles.progressItem}>
						<div className={styles.progressHeader}>
							<span className={styles.progressLabel}>{getStatusLabel(stat._id)}</span>
							<span className={styles.progressValue}>{stat.count}</span>
						</div>
						<div className={styles.progressBarContainer}>
							<div
								className={styles.progressBarFill}
								style={{
									width: totalRegistrations > 0 ? `${(stat.count / totalRegistrations) * 100}%` : "0%",
									backgroundColor: getStatusColor(stat._id),
								}}
							></div>
						</div>
					</div>
				))}
			</div>

			{metadata && (
				<div className={styles.metadataSection}>
					<div className={styles.metadataCard}>
						<div className={styles.metadataIcon}>💰</div>
						<div className={styles.metadataContent}>
							<span className={styles.metadataLabel}>Total Prize Distributed</span>
							<span className={styles.metadataValue}>₹{metadata.totalPrizeDistributed.toLocaleString()}</span>
						</div>
					</div>

					<div className={styles.winnersSection}>
						<h3 className={styles.winnersTitle}>Winners</h3>
						{metadata.winners && metadata.winners.length > 0 ? (
							<div className={styles.winnersList}>
								{metadata.winners.map((winner, index) => (
									<div key={index} className={styles.winnerItem}>
										<div className={styles.winnerRank}>
											{index === 0 ? "🥇" : index === 1 ? "🥈" : index === 2 ? "🥉" : `#${index + 1}`}
										</div>
										<div className={styles.winnerInfo}>
											<span className={styles.winnerName}>{winner.name || winner.teamName}</span>
											<span className={styles.winnerPrize}>₹{winner.prize.toLocaleString()}</span>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className={styles.noWinners}>
								<span className={styles.noWinnersIcon}>🏆</span>
								<span className={styles.noWinnersText}>Winners will be announced after the tournament</span>
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	)
}
